import type { TutorBillingRow } from '@ts-tutor-billing/interfaces'
import type { TutorBillingStore } from './interfaces'
import type { TutorBillingFlag, TutorBillingModal } from '@ts-tutor-billing/enums'
import type { TriState } from '@ts-tutor-billing/types'

import { emptyTutorBillingFilters } from '@helpers/tutor-billing-query'

export const actions = {
  setLoading (this: TutorBillingStore, payload: TutorBillingStore['loading']): void { this.loading = payload },
  setSaving (this: TutorBillingStore, payload: TutorBillingStore['saving']): void { this.saving = payload },
  setRows (this: TutorBillingStore, payload: TutorBillingStore['rows']): void { this.rows = payload },
  setMeta (this: TutorBillingStore, payload: TutorBillingStore['meta']): void { this.meta = payload },
  setFilters (this: TutorBillingStore, payload: TutorBillingStore['filters']): void { this.filters = payload },
  setFilterSearch (this: TutorBillingStore, payload: TutorBillingStore['filters']['search']): void { this.filters.search = payload },
  setFilterTutorIds (this: TutorBillingStore, payload: TutorBillingStore['filters']['tutorIds']): void { this.filters.tutorIds = payload },
  setFilterPaymentServices (this: TutorBillingStore, payload: TutorBillingStore['filters']['paymentServices']): void { this.filters.paymentServices = payload },
  setFilterTutorStatuses (this: TutorBillingStore, payload: TutorBillingStore['filters']['tutorStatuses']): void { this.filters.tutorStatuses = payload },
  setFilterChangeType (this: TutorBillingStore, payload: TutorBillingStore['filters']['changeType']): void { this.filters.changeType = payload },
  setFilterDate (this: TutorBillingStore, payload: Pick<TutorBillingStore['filters'], 'datePreset' | 'dateFrom' | 'dateTo'>): void {
    this.filters.datePreset = payload.datePreset
    this.filters.dateFrom = payload.dateFrom
    this.filters.dateTo = payload.dateTo
  },
  setFilterFlag (this: TutorBillingStore, flag: TutorBillingFlag, value: TriState): void { this.filters.flags[flag] = value },
  resetFilters (this: TutorBillingStore): void {
    this.filters = emptyTutorBillingFilters()
    this.currentPage = 1
  },
  setCurrentPage (this: TutorBillingStore, payload: TutorBillingStore['currentPage']): void { this.currentPage = payload },
  setPerPage (this: TutorBillingStore, payload: TutorBillingStore['perPage']): void { this.perPage = payload },
  setSelectedIds (this: TutorBillingStore, payload: TutorBillingStore['selectedIds']): void { this.selectedIds = payload },
  toggleSelected (this: TutorBillingStore, id: number): void {
    this.selectedIds = this.selectedIds.includes(id)
      ? this.selectedIds.filter(item => item !== id)
      : [...this.selectedIds, id]
  },
  deselect (this: TutorBillingStore, id: number): void { this.selectedIds = this.selectedIds.filter(item => item !== id) },
  clearSelection (this: TutorBillingStore): void { this.selectedIds = [] },
  openModal (this: TutorBillingStore, modal: TutorBillingModal, row: TutorBillingRow | null = null): void {
    this.modal = modal
    this.activeRow = row
  },
  closeModal (this: TutorBillingStore): void {
    this.modal = null
    this.activeRow = null
  },
  setExportType (this: TutorBillingStore, payload: TutorBillingStore['exportType']): void { this.exportType = payload },
  setReturnPath (this: TutorBillingStore, payload: TutorBillingStore['returnPath']): void { this.returnPath = payload },
  replaceRow (this: TutorBillingStore, row: TutorBillingRow): void {
    const index = this.rows.findIndex(item => item.id === row.id)
    if (index === -1) return
    this.rows.splice(index, 1, row)
    if (this.activeRow?.id === row.id) this.activeRow = row
  },
}
